
import { Component, Prop, Vue } from "vue-property-decorator";

interface From {
  title: string;
  child?: From[];
  level: number;
  isShow: boolean;
  active: boolean;
  componentPageName?: string;
  componentIncludeConfig?: string[];
  icon?: string;
  iconActive: boolean;
  badge?: boolean;
}

@Component({})
export default class AsideBar extends Vue {
  @Prop({ default: [] }) sideList!: From[];
  @Prop({ default: false, type: Boolean }) isBaseActive!: boolean;

  activeLv1 = 0;
  activeLv2 = "00";

  translateY = "";
  left = "";
  top = "";
  indicatorHeight = "";
  offset = 0;
  offsetIndex = 0;

  getImage(item: From) {
    if (item.iconActive) {
      return require(`@/views/ai-builder-component/assets/globalFunctional/${item.icon}-active.png`);
    } else {
      return require(`@/views/ai-builder-component/assets/globalFunctional/${item.icon}-default-light.png`);
    }
  }

  getIndicatorPos() {
    if (typeof window === "undefined") {
      return;
    }
    const { activeLv1, activeLv2 } = this;
    const currentLv1 = this.sideList[activeLv1];
    const paddingTop = 2; // 指示器36，标题40，上边空出2
    let numY = 0;
    this.top = "0";
    if (currentLv1.child && currentLv1.child.length && currentLv1.isShow) {
      // 一级展开了，去找当前激活的二级
      const currentLv2 = currentLv1.child[activeLv2[1]];
      const lv2Margin = 15; // 二级标题边距15
      const lv2Ref = this.$refs[currentLv2.componentPageName];
      let el = lv2Ref as HTMLElement;
      if (Array.isArray(lv2Ref)) {
        el = lv2Ref[0] as HTMLElement;
      }
      const { top, left, width } = el.getBoundingClientRect();
      numY =
        top +
        paddingTop +
        (this.offsetIndex < this.activeLv1 ? this.offset : 0);
      this.translateY = numY + "px";
      this.left = left + width + lv2Margin + "px";
    } else {
      // 没有二级菜单或一级没展开直接找一级的位置
      const lv1Margin = 10; // 一级标题边距10
      const lv1Ref = this.$refs[currentLv1.componentPageName || "noName"];
      let el = lv1Ref as HTMLElement;
      if (Array.isArray(lv1Ref)) {
        el = lv1Ref[0] as HTMLElement;
      }
      const { top, left, width } = el.getBoundingClientRect();
      numY =
        top +
        paddingTop +
        (this.offsetIndex < this.activeLv1 ? this.offset : 0);
      this.translateY = numY + "px";
      this.left = left + width + lv1Margin + "px";
    }
    if (numY + 36 > this.scrollBottom) {
      this.indicatorHeight =
        Math.max(0, 36 - (numY + 36 - this.scrollBottom)) + "px";
    } else if (numY < this.scrollTop) {
      this.indicatorHeight = Math.max(0, 36 - (this.scrollTop - numY)) + "px";
      this.top = this.scrollTop - numY + "px";
    } else {
      this.indicatorHeight = "36px";
    }
  }

  classTimer = 0;
  setIndicatorClass() {
    const indicator = this.$refs.indicator as HTMLElement;
    if (indicator) {
      indicator.classList.add("transition");
      this.classTimer = setTimeout(() => {
        indicator.classList.remove("transition");
      }, 300);
    }
  }

  clickLeftLv1(it: From, index: number) {
    this.setIndicatorClass();
    it.isShow = !it.isShow;
    this.offset = 0;
    this.offsetIndex = 0;
    if (!it.child || !it.child.length) {
      this.activeLv1 = index;
      this.activeLv2 = "";
      this.$emit("get", it.componentPageName);
    } else {
      // 单纯展开收起记录高度变化
      const childLen = it.child.length;
      const h = childLen * (40 + 6);
      this.offset = it.isShow ? h : -h;
      this.offsetIndex = index;
    }
    this.$nextTick(() => {
      this.getIndicatorPos();
    });
  }

  clickLeftLv2(it: From, innerIndex: number, outIndex: number) {
    this.setIndicatorClass();
    this.offset = 0;
    this.offsetIndex = 0;
    it.active = !it.active;
    this.activeLv1 = outIndex;
    this.activeLv2 = String(outIndex) + String(innerIndex);
    this.$nextTick(() => {
      this.getIndicatorPos();
    });
    this.$emit("get", it.componentPageName);
  }

  getHeight(child?: From[]) {
    if (child) {
      const l = child.length;
      return l * (40 + 6) + "px";
    }
    return "auto";
  }

  rafId = 0;
  throttle(fn: any) {
    if (this.rafId) {
      return;
    }
    fn();
    this.rafId = requestAnimationFrame(() => {
      this.rafId = 0;
    });
  }

  scrollBottom = 0;
  scrollTop = 0;

  beforeGetPosNeedClear() {
    this.offset = 0;
    this.offsetIndex = 0;
    this.throttle(this.getIndicatorPos);
  }

  getScrollRect() {
    const leftScroll = this.$refs.leftScroll as HTMLElement;
    const rect = leftScroll.getBoundingClientRect();
    this.scrollBottom = rect.bottom;
    this.scrollTop = rect.top;
    leftScroll.addEventListener("scroll", this.beforeGetPosNeedClear);
  }

  initActive() {
    if (this.isBaseActive) {
      return;
    }
    this.activeLv1 = 0;

    if (!this.sideList[0]?.child?.length) {
      this.$emit("get", this.sideList[0].componentPageName);
    }

    this.activeLv2 = "00";
    this.$emit("get", this.sideList[0].child?.[0].componentPageName);
  }

  resize() {
    this.getScrollRect();
    this.throttle(this.getIndicatorPos);
  }

  mounted() {
    this.getScrollRect();
    this.initActive();
    this.getIndicatorPos();
    window.addEventListener("resize", this.resize);
  }

  beforeDestory() {
    const leftScroll = this.$refs.leftScroll as HTMLElement;
    if (leftScroll) {
      leftScroll.removeEventListener("scroll", this.beforeGetPosNeedClear);
    }
    window.removeEventListener("resize", this.resize);
    clearTimeout(this.classTimer);
  }
}
